<input class="datepicker-input" #textInput type="text" readonly />
<div #datepickerContainer class="datepicker-container"></div>
